import { apiSlice } from "@/shared/api/api-slice"
import type { BusinessSubscription } from "@/shared/types/api/business-mode.types"

export const getSubscriptionApi = apiSlice
  .enhanceEndpoints({
    addTagTypes: ["BusinessSubscription"]
  })
  .injectEndpoints({
    endpoints: builder => ({
      getSubscription: builder.query<BusinessSubscription, void>({
        query: () => `/api/v1/business/subscriptions`,
        providesTags: () => [{ type: "BusinessSubscription" as const }]
      })
    })
  })

export const { useGetSubscriptionQuery } = getSubscriptionApi
